import Highcharts from 'highcharts/highmaps';
import HighchartsReact from 'highcharts-react-official';
import exporting from 'highcharts/modules/exporting';
import React, { useEffect, useState, useRef } from 'react';
import NewMapData from './NewMapData';

if (typeof exporting === 'function') {
  exporting(Highcharts);
}

const MapChart = ({ selectedState, PanIndia }) => {
  const [options, setOptions] = useState(null);
  const chartRef = useRef(null); // Create a ref for the chart

  useEffect(() => {
    Highcharts.maps['countries/in/custom/in-all-disputed'] = NewMapData;

    const selectedStates = selectedState
      ? selectedState.split(", ").map(s => s.toLowerCase())
      : [];

    const allStatesData = NewMapData?.features?.map((feature, index) => {
      const id = feature?.properties?.['hc-key'];
      const isSelected = selectedStates.includes(id);
      return {
        'hc-key': id,
        value: index + 1,
        color: PanIndia ? (isSelected ? '#fec74e' : '#e3f4fa') : (isSelected ? '#fec74e' : undefined),
        // only add color when PanIndia is true or state is selected
      };
    }).filter(data => PanIndia || selectedStates.includes(data['hc-key'])); // Filter for non-PanIndia

    setOptions({
      tooltip: {
        format: '{point.name}'
      },
      navigation: {
        buttonOptions: {
          enabled: false
        }
      },
      chart: {
        map: 'countries/in/custom/in-all-disputed',
        events: {
          load: function () {
            chartRef.current = this;
          },
        },
      },
      title: {
        text: '',
      },
      plotOptions: {
        series: {
          allowPointSelect: true,
          borderColor: '#004878', // set blue border normally
          borderWidth: 1,         // optional, control thickness
          states: {
            hover: {
              color: 'transparent',
            },
            select: {
              color: '#fec74e',
              borderColor: '#004878',
              borderWidth: 2,
            },
          },
        },
      },
      legend: {
        enabled: false
      },
      series: [
        {
          data: allStatesData,
          name: 'States Data',
          mapData: Highcharts.maps['countries/in/custom/in-all-disputed'],
        }
      ],
    });
  }, [selectedState, PanIndia]);



  useEffect(() => {
    // Programmatically select the state when selectedState prop changes
    if (chartRef.current && selectedState && !PanIndia) {
      const statesToSelect = selectedState.split(", ").map(s => s.toLowerCase());
      chartRef.current.series[0].points.forEach(point => {
        const shouldSelect = statesToSelect.includes(point.id); // Assuming your map data has lowercase state abbreviations as IDs
        point.select(shouldSelect, true); // true to select, true to keep previous selections
      });
    } else if (chartRef.current && PanIndia) {
      // Deselect all if PanIndia is true
      chartRef.current.series[0].points.forEach(point => {
        point.select(false, true);
      });
    }
  }, [selectedState, PanIndia]);

  if (!options) return <p>Loading...</p>;

  return (
    <HighchartsReact
      highcharts={Highcharts}
      constructorType="mapChart"
      options={options}
    />
  );
};

export default MapChart;